<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >{{ $t("Cookies.text1") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card class="rounded-lg">
                <v-card-title primary-title class="pa-2 pl-4 black--text">
                  {{ $t("Cookies.text2") }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-5">
                  <v-layout row wrap justify-center align-start>
                    <v-flex xs11 lg5 md5 pa-2>
                      <b class="red--text mr-1">*</b>
                      <b class="black--text">{{ $t("Cookies.text3") }}</b>
                      <v-text-field
                        outlined
                        dense
                        color="info"
                        v-model="SystemName"
                        :rules="[(v) => !!v || 'กรุณากรอกชื่อระบบ']"
                        hint=""
                        persistent-hint
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs11 lg5 md5 pa-2>
                      <b class="red--text mr-1">*</b>
                      <b class="black--text">{{ $t("Cookies.text4") }}</b>
                      <v-text-field
                        hide-details
                        outlined
                        dense
                        color="info"
                        v-model="DomainName"
                        :rules="HostRules"
                        hint=""
                        persistent-hint
                      >
                      </v-text-field>
                      <b class="red--text mr-1"
                        >ตัวอย่าง : {{ url }}</b
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center mt-n8>
                    <v-flex xs11 lg10 pa-2>
                      <v-radio-group
                        @change="Fn_CheckType"
                        v-model="ConsentType"
                        :rules="[(v) => !!v || 'กรุณาเลือกรูปแบบการส่ง']"
                        row
                      >
                        <v-radio
                          :label="$t('onechat.text6')"
                          color="#077893"
                          value="SentGeneral"
                        >
                        </v-radio>
                        <v-radio
                          :label="$t('onechat.text7')"
                          color="#077893"
                          value="SentGroup"
                        >
                        </v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center mt-n4>
                    <v-flex xs11 lg5 pa-2 v-if="ConsentType === 'SentGeneral'">
                      <b class="red--text mr-1">*</b>
                      <b class="black--text">{{ $t("onechat.text8") }} </b>
                      <v-select
                        dense
                        :items="ItemPolicy"
                        :label="$t('onechat.text8')"
                        :rules="[(v) => !!v || 'กรุณาเลือกนโยบายแบบทั่วไป']"
                        item-text="Title"
                        v-model="SelectPolicy"
                        item-value="PolicyId"
                        outlined
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs11 lg5 pa-2 v-if="ConsentType === 'SentGeneral'">
                      <b class="red--text mr-1">*</b>
                      <b class="black--text">{{ $t("onechat.text9") }} </b>
                      <v-select
                        v-if="ConsentType === 'SentGeneral'"
                        dense
                        :items="ItemConsentGeneral"
                        :label="$t('onechat.text9')"
                        :rules="[(v) => !!v || 'กรุณาเลือกความยินยอมแบบทั่วไป']"
                        item-text="HeaderConsent"
                        v-model="SelectConsentGeneral"
                        item-value="ConsentId"
                        outlined
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs11 lg5 pa-2 v-if="ConsentType === 'SentGroup'">
                      <b class="red--text mr-1">*</b>
                      <!-- <b>{{ $t("onechat.text9") }} </b> -->
                      <b class="black--text">{{ $t("mcg.consent2") }} </b>
                      <!-- <v-select dense :items="ItemConsentGroup" :label="$t('onechat.text9')" :rules="[(v) => !!v]"
                          item-text="GroupName" v-model="SelectConsentGroup" item-value="GroupId" outlined>
                        </v-select> -->
                      <v-select
                        dense
                        :items="ItemConsentGroup"
                        :label="$t('mcg.consent2')"
                        :rules="[(v) => !!v || $t('consentform.exdate2')]"
                        item-text="GroupName"
                        v-model="SelectConsentGroup"
                        item-value="GroupId"
                        outlined
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs11 lg5></v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-layout row wrap justify-center align-center pb-5>
                    <!-- <v-flex xs2 lg2 mr-2>
                      <v-btn block dark outlined color="#077893" @click="Fn_CreatePolicy">บันทึกฉบับร่าง</v-btn>
                    </v-flex> -->
                    <v-flex xs9 md3 lg3>
                      <v-btn
                        block
                        dark
                        color="#077893"
                        :loading="LoadingAdd"
                        @click="Fn_InsertService"
                        >{{ $t("policy.text6") }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {},
  data: function () {
    return {
      valid: true,
      url: process.env.VUE_APP_API_DOMAIN,
      ItemPolicy: [],
      SystemName: "",
      DomainName: "",
      ConsentType: "SentGeneral",
      SelectConsentGeneral: "",
      SelectConsentGroup: " ",
      SelectPolicy: "",
      LoadingAdd: false,
      ItemConsentGeneral: [],
      ItemConsentGroup: [],
      HostRules: [
        (v) => !!v || "กรุณากรอกชื่อโดเมน",
        (v) => /.+.+\..+/.test(v) || "รูปแบบของโดเมนไม่ถูกต้อง",
      ],
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    _BusinessName: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
    Fn_CheckType() {
      if (this.ConsentType == "SentGeneral") {
        this.SelectConsentGroup = [];
      } else {
        this.SelectPolicy = [];
        this.SelectConsentGeneral = [];
      }
    },
  },
  mounted() {
    this.Fn_GetPolicy();
    this.Fn_GetConsentGeneral();
    this.Fn_GetConsentGroup();
  },
  methods: {
    Fn_SelectTypeDepartment() {
      if (this.TypeSent === "SentDepartment") {
        this.Fn_GetAllDepartment();
      } else if (this.TypeSent === "SentAll") {
        this.SelectDepartment = "";
        this.SelectRole = "";
        this.$refs.formConsent.resetValidation();
        this.Fn_GetAllEmployee();
      }
    },
    async Fn_GetPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      // var Headers = {
      //
      //   AccountId: this.$cookies.get("OneAccountId"),
      // };
      // var dataEncode = await authorization.encodeDataNew(payload);
      // var auth = await authorization.encodeDataNew(Headers);
      // var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          // { Data: dataEncode },
          // { headers }
          payload
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGeneral() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      // var Headers = {
      //
      //   AccountId: this.$cookies.get("OneAccountId"),
      // };
      // var dataEncode = await authorization.encodeDataNew(payload);
      // var auth = await authorization.encodeDataNew(Headers);
      // var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetApiAllDetailConsent",
          // { Data: dataEncode },
          // { headers }
          payload
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemConsentGeneral = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGroup() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      // var Headers = {
      //
      //   AccountId: this.$cookies.get("OneAccountId"),
      // };
      // var dataEncode = await authorization.encodeDataNew(payload);
      // var auth = await authorization.encodeDataNew(Headers);
      // var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetApiAllGroupConsent",
          // { Data: dataEncode },
          // { headers }
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsentGroup = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_InsertService() {
      if (this.$refs.form.validate()) {
        var payload = {};
        this.LoadingAdd = true;
        if (this.ConsentType === "SentGeneral") {
          payload = {
            BusinessId: this.$cookies.get("BusinessId"),
            AccountId: this.$cookies.get("OneAccountId"),
            ServiceName: this.SystemName,
            Hostname: this.DomainName,
            PolicyId: this.SelectPolicy,
            ConsentId: this.SelectConsentGeneral,
            GroupId: "",
          };
        } else {
          payload = {
            BusinessId: this.$cookies.get("BusinessId"),
            AccountId: this.$cookies.get("OneAccountId"),
            ServiceName: this.SystemName,
            Hostname: this.DomainName,
            PolicyId: "",
            ConsentId: "",
            GroupId: this.SelectConsentGroup,
          };
        }
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "webscript/InsertServiceId",
            payload
          )
          .then((response) => {
            this.LoadingAdd = false;


            if (response.data.Status === "OK") {
              this.ItemPolicy = response.data.Message;
              Toast.fire({
                icon: "success",
                title: response.data.Message,
              });
              this.$router.push("/cookies-index");
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.LoadingAdd = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    Fn_BackIndex() {
      this.$router.push("/cookies-index");
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
.v-input__slot {
  margin: 0 !important;
}
</style>
